import { BadgeCheck } from "lucide-react";

export const VerifiedBadge = ({ show, size = 15, className = "", testId }) => {
  if (!show) return null;
  return (
    <span data-testid={testId || "verified-badge"} title="Verified archivist" aria-label="Verified" className={`inline-flex shrink-0 align-middle ${className}`}>
      <BadgeCheck size={size} className="text-white" fill="#0066FF" strokeWidth={2.2} />
    </span>
  );
};
